import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { getRequirementDefinitionTableCellProps } from "../../../../RequirementDefinitions/utils";
import { CustomRequirement } from "../../../types";
import { getPayoutMethodRequirementName } from "../../PayoutMethod/configs/helpers/getPayoutMethodRequirementName";
import { getPayoutMethodRequirementPayerStatusCell } from "../../PayoutMethod/configs/helpers/getPayoutMethodRequirementPayerStatusCell";
import { getClientsCellProps } from "../helpers/getClientsCellProps";

export function useGetPayoutMethodCustomRequirement(): (
  requirements: PayeeRequirement[]
) => CustomRequirement {
  return requirements => {
    const baseRequirement = requirements[0];

    return {
      payerAccountId: baseRequirement.payerAccountId!,
      payeeEngagementIds: baseRequirement.payeeEngagementIds,
      status: baseRequirement.status!,
      nameCell: {
        text: getPayoutMethodRequirementName(baseRequirement)
      },
      typeCell: getRequirementDefinitionTableCellProps({
        type: baseRequirement.type!
      }),
      clientsCell: getClientsCellProps(requirements),
      engagementsCell: {},
      statusCell: getPayoutMethodRequirementPayerStatusCell(baseRequirement),
      menuActions: []
    };
  };
}
